import React from 'react';
import { useAtomValue } from 'jotai';
import { Box } from '@mui/material';
import { ColumnFlexBox, CenteredFlexBox } from '../FlexBox';
import Logo from '../Logos/Logo';
import { themeAtom } from '../../Atoms';
import IconButton from '../Button/IconButton';
import CollapseSidebar from '../../assets/icons/CollapseSidebar';
import OpenSidebar from '../../assets/icons/OpenSidebar';
import BranchSelect from './BranchSelect';
import { TRANSITION_DURATION } from './StyledDrawer';

/** How tall the mark stands, open or collapsed, so the header never changes height. */
const MARK_HEIGHT = '38px';

/**
 * How wide the wordmark is drawn, and how much of it the rail shows: the mark spans the first fifth
 * of the drawing (about 38px at this size), and the name starts after it.
 */
const WORDMARK_WIDTH = '190px';
const MARK_ONLY_WIDTH = '40px';

const SidebarHeader = function SidebarHeader({
  open,
  toggleSidebar,
  handleSelectBranch,
}) {
  const themeMode = useAtomValue(themeAtom);

  return (
    <ColumnFlexBox padding="16px" gap="16px">
      <CenteredFlexBox
        sx={{
          flexDirection: open ? 'row' : 'column',
          justifyContent: 'center',
          gap: open ? 0 : '12px',
        }}
      >
        {/* One wordmark, never swapped: its slot narrows with the rail until only the mark at its
            left edge is left, while the name fades out ahead of the clip. The mark is the same
            drawing in both states, so it keeps its gradient rather than turning into a flat icon. */}
        <Box
          sx={{
            flex: 'none',
            overflow: 'hidden',
            height: MARK_HEIGHT,
            width: open ? WORDMARK_WIDTH : MARK_ONLY_WIDTH,
            transition: `width ${TRANSITION_DURATION}s ease-in-out`,
          }}
        >
          <Logo
            viewBox="0 0 1000 200"
            width={WORDMARK_WIDTH}
            height={MARK_HEIGHT}
            textColor={themeMode === 'light' ? '#1d1d1b' : '#fff'}
            textStyle={{
              opacity: open ? 1 : 0,
              transition: `opacity ${TRANSITION_DURATION * (open ? 1.2 : 0.5)}s ease-in-out`,
            }}
            logoColor={themeMode === 'dark' ? '#1d1d1b' : '#fff'}
          />
        </Box>
        <IconButton
          title={open ? 'COLLAPSE_SIDEBAR' : 'OPEN_SIDEBAR'}
          onClick={toggleSidebar}
          iconProps={{ sx: { padding: 'unset' } }}
        >
          {open ? <CollapseSidebar size={24} /> : <OpenSidebar size={24} />}
        </IconButton>
      </CenteredFlexBox>
      {/* Taken out of the flow rather than merely hidden: at `visibility: hidden` the select was
          still laid out, so every frame of the rail's animation squeezed a 288px control into 68px
          for nothing. */}
      {open && (
        <Box>
          <BranchSelect
            handleChangeBranch={handleSelectBranch}
            sidebarOpen={open}
          />
        </Box>
      )}
    </ColumnFlexBox>
  );
};

export default SidebarHeader;
